import { Button, CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoadTextField from '../LoadTextField';
import { updateBusiness } from '../../actions/business';
import * as api from '../../api';
import { useDispatch } from 'react-redux';


function Business(props) {
  const { business } = props;
  const dispatch = useDispatch();

  const [editBusiness, setEditBusiness] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setEditBusiness(business);
  }, [business]);
  
  const getVal = (key) => {
    return editBusiness?.[key];
  }
  const setVal = (key, val) => {
    setEditBusiness({ ...editBusiness, [key]: val });
  }
  const getValNullable = (key) => {
    return editBusiness?.[key] || '';
  }
  const setValNullable = (key, val) => {
    setEditBusiness({ ...editBusiness, [key]: val === '' ? null : val });
  }

  const handleSubmit = evt => {
    evt.preventDefault();
    setSaving(true);

    const { id, ...data } = editBusiness;

    api.updateBusiness(id, data)
      .then(res => dispatch(updateBusiness(res)))
      .catch(err => console.warn(err))
      .finally(() => setSaving(false));
  }
  
  const loading = editBusiness == null;

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='Name'
            loading={loading}
            value={getVal('name')}
            onChange={evt => setVal('name', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='Address'
            loading={loading}
            value={getVal('address')}
            onChange={evt => setVal('address', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='City'
            loading={loading}
            value={getVal('city')}
            onChange={evt => setVal('city', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='Zip'
            loading={loading}
            value={getVal('zip')}
            onChange={evt => setVal('zip', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='State'
            loading={loading}
            value={getVal('state')}
            onChange={evt => setVal('state', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='Industry'
            loading={loading}
            value={getVal('industry')}
            onChange={evt => setVal('industry', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='Website'
            loading={loading}
            value={getValNullable('website')}
            onChange={evt => setValNullable('website', evt.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <LoadTextField
            variant='outlined'
            label='URL'
            loading={loading}
            value={getValNullable('url')}
            onChange={evt => setValNullable('url', evt.target.value)}
          />
        </Grid>
      </Grid>

      <br />

      {saving
        ? <CircularProgress />
        : <Button
            variant='outlined'
            type='submit'
          >
            SAVE
          </Button>}
    </form>
  );
}

Business.propTypes = {
  business: PropTypes.object
}

export default Business;
